import cntl from "cntl";
import PropTypes from "prop-types";
import TabButton from "./TabButton";
import { useState, useMemo } from "react";
import { SIZE } from "../constants/index";

const propTypes = {
  id: PropTypes.string,
  onClick: PropTypes.func,
  label: PropTypes.string,
  tabIndex: PropTypes.string,
  isDisabled: PropTypes.bool,
  className: PropTypes.string,
  ariaSelected: PropTypes.string,
  ariaControls: PropTypes.string,
  size: PropTypes.oneOf([SIZE.sm, SIZE.md]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

function TabButtonUnderlineFilled({
  id,
  size,
  label,
  onClick,
  children,
  tabIndex,
  className,
  isDisabled,
  ariaSelected,
  ariaControls,
}) {
  const [padding, setPadding] = useState("");

  const tabButtonUnderlineFilledCn = () => cntl`
    border-b-2
    rounded-t-none
    border-b-transparent
    ${padding}
    ${
      ariaSelected === "true"
        ? cntl`text-primary-700 border-b-primary-700 bg-primary-50 rounded-b-none`
        : !!!isDisabled &&
          cntl`text-grey-500 hover:text-primary-700 hover:border-b-primary-700 hover:bg-primary-50 hover:rounded-b-none 
        bg-transparent`
    }
    ${className ? className : undefined}
  `;

  useMemo(() => {
    switch (size) {
      case SIZE.sm:
        setPadding("pt-3 pb-2.5 px-3");
        break;
      case SIZE.md:
        setPadding("pt-3 pb-2.5 px-3");
        break;
      default:
        setPadding("pt-3 pb-2.5 px-3");
        break;
    }
  }, [size]);

  return (
    <TabButton
      id={id}
      size={size}
      label={label}
      onClick={onClick}
      tabIndex={tabIndex}
      isDisabled={isDisabled}
      ariaSelected={ariaSelected}
      ariaControls={ariaControls}
      className={tabButtonUnderlineFilledCn()}
    >
      {children}
    </TabButton>
  );
}

TabButtonUnderlineFilled.propTypes = propTypes;
export default TabButtonUnderlineFilled;
